import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://gttxlxlwahofhyhkcdve.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0dHhseGx3YWhvZmh5aGtjZHZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwMjg2NDIsImV4cCI6MjA2NTYwNDY0Mn0.LPhZDDq76VM45LIKJEZoXW_J2uGdgHrbq0uu9h65VHo'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
}) 